<template>
  <div class="col-sm-12">
    <div class="card custom-card">

      <!-- added by isindu | 2025/ 12/ 02 -->
      <div v-if="loading" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>


      <div v-else> <!-- added by isindu | 2025/ 12/ 02 -->
        <!-- Bank Selection Dropdown -->
        <div class="form-group">
          <label for="Bank" class="block mb-2 font-semibold">
            Bank Name : <span class="text-red-500">*</span>
          </label>
          <select v-model="selectedBank" id="Bank" class="custom-select" :disabled="isSaving">
            <option disabled value="">Select Bank</option>
            <option v-for="Bank in BankList" :key="Bank.id" :value="Bank.id">
              {{ Bank.bank_name }}
            </option>
          </select>
        </div>
      </div> <!-- added by isindu | 2025/ 12/ 02 -->

      <!-- Branch Selection Dropdown -->
      <div class="form-group">
        <label for="Branch" class="block mb-2 font-semibold">
          Branch Name : <span class="text-red-500">*</span>
        </label>
        <select v-model="selectedBranch" id="Branch" class="custom-select" :disabled="isSaving || !selectedBank">
          <option disabled value="">Select Branch</option>
          <option v-for="Branch in BranchList" :key="Branch.id" :value="Branch.id">
            {{ Branch.branch_name }}
          </option>
        </select>
      </div>

      <!-- Account Name Input -->
      <div class="form-group">
        <label for="name" class="block mb-2 font-semibold">
          Account Name : <span class="text-red-500">*</span>
        </label>
        <input type="text" id="name" v-model="name" placeholder="Enter Account Name" class="name-input"
          :disabled="isSaving" />
      </div>

      <!-- Account Number Input -->
      <div class="form-group">
        <label for="accountNumber" class="block mb-2 font-semibold">
          Account No : <span class="text-red-500">*</span>
        </label>
        <input type="text" id="accountNumber" v-model="accountNumber" placeholder="Enter Account No" class="name-input"
          :disabled="isSaving" />
      </div>

      <!-- Active Toggle -->
      <div class="form-group toggle-container">
        <label for="isActive" class="form-label">Is Active :</label>
        <div class="toggle-wrapper">
          <label class="toggle-switch" :class="{ 'active': isActive, 'inactive': !isActive }">
            <input type="checkbox" id="isActive" v-model="isActive" :disabled="isSaving" hidden />
            <span class="toggle-slider"></span>
          </label>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="d-flex justify-content-end action-buttons">
        <button type="button" class="btn btn-danger" @click="Cancel" :disabled="isSaving">
          Cancel
        </button>
        <button type="button" class="btn btn-success save-button" @click="updateBanks"
          :disabled="isSaving || !isFormValid">
          <span v-if="!isSaving">Update</span>
          <div v-else class="loading-indicator">
            <span class="spinner"></span>
            <span>Updating...</span>
          </div>
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { getBankList, fetchBranchList, editBankDetailsById, updateBankDetails } from "@/services/dataService";
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      token: localStorage.getItem('token_set') || '',
      profileId: localStorage.getItem("profile_id"),
      reportingProfileId: localStorage.getItem("reportingL1ProfileId"),
      userCategory: localStorage.getItem("user_label"),
      router: useRouter(),
      branch_id: '',
      bankId: null,
      BankList: [],
      BranchList: [],
      selectedBank: "",
      selectedBranch: "",
      name: "",
      accountNumber: "",
      isActive: true,
      banksId: this.$route.params.id || 1,
      isSaving: false,
      loading: false, // added by isindu | 2025/ 12/ 02
    }
  },

  computed: {
    isFormValid() {
      return this.selectedBank &&
        this.selectedBranch &&
        this.name.trim() &&
        this.accountNumber.trim();
    }
  },

  watch: {
    selectedBank(newBankId) {
      if (newBankId) {
        this.loadBranchList();
      } else {
        this.BranchList = [];
        this.selectedBranch = "";
      }
    }
  },

  created() {
    this.bankId = this.$route.params.id;
    this.loadBankList();
    this.loadBankDetails();
  },

  methods: {
    async loadBankList() {
      try {
        const response = await getBankList(this.token);
        this.BankList = response.data.data || [];
        console.log('Fetched BankList:', this.BankList);
      } catch (error) {
        console.error('Error fetching BankList:', error);
      }
    },

    async loadBranchList() {
      if (!this.selectedBank) return;

      const payload = {
        bank_id: this.selectedBank,
      };

      try {
        const response = await fetchBranchList(payload, this.token);
        this.BranchList = response.data.data || [];
        console.log('Fetched BranchList:', this.BranchList);
      } catch (error) {
        console.error("Error fetching branches:", error.response);
        this.BranchList = [];
      }
    },

    async loadBankDetails() {
      this.loading = true; // added by isindu | 2025/ 12/ 02

      try {
        const response = await editBankDetailsById(this.bankId, this.token);
        const bankData = response.data.data;

        if (bankData) {
          this.selectedBank = bankData.bank_id;
          this.selectedBranch = bankData.branch_id;
          this.name = bankData.account_name;
          this.accountNumber = bankData.account_no;
          this.isActive = bankData.is_active === "1" ? true : false;

          // Load branches for the selected bank
          if (this.selectedBank) {
            await this.loadBranchList();
          }
        }

        console.log("Fetched bank details:", bankData);
      } catch (error) {
        console.error("Error fetching bank details:", error);
      }
      //added by isindu | 2025/ 12/ 02
      finally {
        this.loading = false;
      }
    },

    async updateBanks() {
      if (!this.selectedBank) {
        useToast().error("Please select a bank.");
        return;
      }

      if (!this.selectedBranch) {
        useToast().error("Please select a branch.");
        return;
      }

      if (!this.name.trim()) {
        useToast().error("Please enter an account name.");
        return;
      }

      if (!this.accountNumber.trim()) {
        useToast().error("Please enter an account number.");
        return;
      }

      // Set saving state
      this.isSaving = true;

      let idToUse = this.profileId;
      if (this.userCategory === 'DISTRIBUTOR BACK OFFICE') {
        idToUse = this.reportingProfileId;
      }

      const payload = {
        profile_id: idToUse,
        branch_id: this.selectedBranch,
        account_no: this.accountNumber,
        account_name: this.name,
        is_active: this.isActive ? "1" : "0",
      };

      try {
        const response = await updateBankDetails(this.banksId, this.token, payload);
        useToast().success("Bank details updated successfully!");
        this.$router.push('/distributor-banks');
      } catch (error) {
        console.error("Error response:", error.response);
        useToast().error("Failed to update bank details. Please try again.");
      } finally {
        this.isSaving = false;
      }
    },

    Cancel() {
      if (!this.isSaving) {
        this.$router.push({ path: "/distributor-banks" });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.custom-card {
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 5px;
  padding: 16px;
}

.custom-select {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 12px;
  width: 100%;
  margin-top: 8px;
  font-size: 16px;
  background-color: white;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  &:disabled {
    background-color: #e9ecef;
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.name-input {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 12px;
  width: 100%;
  margin-top: 8px;
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  &:disabled {
    background-color: #e9ecef;
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.toggle-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;

  .form-label {
    margin-bottom: 0;
    font-weight: 500;
  }
}

.toggle-wrapper {
  display: flex;
  align-items: center;
}

.toggle-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  &.active .toggle-slider {
    background-color: #28a745;

    &::before {
      transform: translateX(24px);
    }
  }

  &.inactive .toggle-slider {
    background-color: #dc3545;

    &::before {
      transform: translateX(0);
    }
  }
}

.toggle-slider {
  width: 50px;
  height: 26px;
  background-color: #ccc;
  border-radius: 34px;
  position: relative;
  transition: all 0.3s ease;

  &::before {
    content: "";
    position: absolute;
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    border-radius: 50%;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
}

.action-buttons {
  padding: 16px;
  gap: 12px;

  .btn {
    padding: 10px 20px;
    border-radius: 4px;
    font-weight: 500;
    min-width: 100px;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}

.save-button {
  position: relative;
  min-width: 120px;
}

.loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.text-red-500 {
  color: #dc3545;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .custom-card {
    padding: 16px;
  }

  .form-group {
    padding: 12px;
  }
}


/* added by isindu | 2025/ 12/ 02 */
.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin: 20px 0;
  color: #007bff;
}
</style>